import type { CatalogEntry } from '../types';

/**
 * Audit logs (feature `19`) error codes + catalog.
 *
 * Code shape is `19AAEE` (decimal, zero-padded):
 *   - `AA` = endpoint within the feature (`00` = feature-level / cross-endpoint).
 *   - `EE` = specific condition within that endpoint.
 *
 * Endpoint → `AA` map:
 *   shared=00 (cross-endpoint), getById=02 (GET /audit-logs/:id).
 *
 * Audit logs are admin-only: org owners/admins see the whole org, workspace
 * admins see their workspace. A caller who is neither is forbidden (`00`); a
 * by-id fetch that misses or falls outside the caller's scope is not-found (`02`).
 */
export const AUDIT_LOGS_CODES = {
  /** Cross-endpoint (shared=00). */
  Shared: {
    Forbidden: '190001',
  },
  /** GET /audit-logs/:id (getById=02). */
  NotFound: '190201',
} as const;

export const AUDIT_LOGS_CATALOG: Record<string, CatalogEntry> = {
  '190001': {
    httpStatus: 403,
    message: "You don't have permission to view audit logs.",
  },
  '190201': {
    httpStatus: 404,
    message: "We couldn't find that audit-log entry.",
  },
};
